import React, { useEffect, useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import {
  ExpandFiltersButton,
  ExportButton,
  ExportButtonProps,
  MOBILE_FILTER_ROW_HEIGHT,
  ResetFiltersButton,
  StyledFilterIconButton
} from './filterActionButtons';

type MobilePrimaryFilterRowProps = {
  hasSearchFilter: boolean;
  searchInput?: React.ReactNode;
  getSearchValue?: () => string | null | undefined;
  onClearSearch?: () => void;
  otherPrimaryContent?: React.ReactNode;
  hasActiveFilters: boolean;
  onReset: () => void;
  regularFiltersLength: number;
  expanded: boolean;
  onToggleFilters: () => void;
  exportProps: ExportButtonProps;
  centerActions?: boolean;
};

export const MobilePrimaryFilterRow = ({
  hasSearchFilter,
  searchInput,
  getSearchValue,
  onClearSearch,
  otherPrimaryContent,
  hasActiveFilters,
  onReset,
  regularFiltersLength,
  expanded,
  onToggleFilters,
  exportProps,
  centerActions = false
}: MobilePrimaryFilterRowProps) => {
  const searchValue = getSearchValue?.() ?? '';
  const [searchOpen, setSearchOpen] = useState(() => Boolean(searchValue));

  useEffect(() => {
    if (searchValue) {
      setSearchOpen(true);
    }
  }, [searchValue]);

  const handleSearchToggle = () => {
    if (searchOpen) {
      onClearSearch?.();
      setSearchOpen(false);
      return;
    }
    setSearchOpen(true);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: centerActions ? 0.75 : 1,
        width: '100%',
        minHeight: MOBILE_FILTER_ROW_HEIGHT,
        justifyContent: centerActions && !searchOpen ? 'center' : undefined
      }}
    >
      <ExpandFiltersButton
        regularFiltersLength={regularFiltersLength}
        expanded={expanded}
        onToggle={onToggleFilters}
      />
      {hasSearchFilter && (
        <Tooltip title={searchOpen ? 'סגור חיפוש' : 'חיפוש'}>
          <StyledFilterIconButton onClick={handleSearchToggle} aria-label={searchOpen ? 'סגור חיפוש' : 'חיפוש'}>
            {searchOpen ? <CloseIcon fontSize="small" /> : <SearchOutlined fontSize="small" />}
          </StyledFilterIconButton>
        </Tooltip>
      )}
      {hasSearchFilter && (
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            width: 0,
            display: searchOpen ? 'flex' : 'none',
            alignItems: 'center',
            '& > *': { width: '100%' },
            '& .SmInputBase-root': {
              minHeight: MOBILE_FILTER_ROW_HEIGHT - 4,
              height: MOBILE_FILTER_ROW_HEIGHT - 4,
              boxSizing: 'border-box'
            },
            '& .MuiInputBase-input': {
              paddingTop: '7px',
              paddingBottom: '7px'
            }
          }}
        >
          {searchInput}
        </Box>
      )}
      {otherPrimaryContent}
      <ResetFiltersButton hasActiveFilters={hasActiveFilters} onReset={onReset} />
      <ExportButton {...exportProps} />
    </Box>
  );
};
